import { connect } from 'react-redux';
import {
  setDraftAccount,
  setViewId,
} from '../../../MultiWorkflows/FinancialAccountsWorkflow/Steps/AccountsManualStepActions';
import { BASE_ACCOUNT } from '../../../MultiWorkflows/FinancialAccountsWorkflow/FinancialAccountsWorkflowConstants';
import { ADD } from '../../../MultiWorkflows/FinancialAccountsWorkflow/Steps/AccountsManualStepViews';
import { currentClientIdOrDefaultSelector } from '../../../MultiWorkflows/AdvWorkflow/AdvWorkflowSelector';
import View from './QuovoSearchInstitutionView';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onManualAddAccountPressed: workflowId => event => {
    if (ownProps.onManualAddAccountPressed) {
      ownProps.onManualAddAccountPressed(event);
    } else {
      dispatch(setDraftAccount(BASE_ACCOUNT, workflowId));
      dispatch(setViewId(ADD, workflowId));
      event.stopPropagation();
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
